export type RefundUIStrategy =
  | "PARTIAL_AMOUNT"
  | "PARTIAL_PERCENTAGE"
  | "PARTIAL_QUANTITY"
  | "SHIPPING_ONLY"
  | "FULL_REFUND";

export type RefundItemInputType = "amount" | "percentage" | "quantity" | "none";

export type RefundOptionConfig = {
  label: string;
  inputType: RefundItemInputType;
  /** Column header next to the item dropdown when the strategy has item rows. */
  itemColumnHeader?: string;
};

/**
 * Per-strategy UI config. `inputType` selects the per-item value a row collects:
 *   - "amount"     — dollar input per item
 *   - "percentage" — percent input per item (0-100)
 *   - "quantity"   — integer quantity input per item
 *   - "none"       — no item rows (shipping only / full refund)
 */
export const REFUND_OPTION_CONFIG: readonly { value: RefundUIStrategy; config: RefundOptionConfig }[] = [
  {
    value: "PARTIAL_AMOUNT",
    config: { label: "Partial Refund ($)", inputType: "amount", itemColumnHeader: "Amount" },
  },
  {
    value: "PARTIAL_QUANTITY",
    config: { label: "Partial Refund (Qty.)", inputType: "quantity", itemColumnHeader: "Qty." },
  },
  {
    value: "PARTIAL_PERCENTAGE",
    config: { label: "Partial Refund (%)", inputType: "percentage", itemColumnHeader: "%" },
  },
  { value: "SHIPPING_ONLY", config: { label: "Shipping Only Refund", inputType: "none" } },
  { value: "FULL_REFUND", config: { label: "Full Refund", inputType: "none" } },
];

export function getRefundOptionConfig(strategy: RefundUIStrategy | undefined): RefundOptionConfig | undefined {
  return REFUND_OPTION_CONFIG.find((entry) => entry.value === strategy)?.config;
}
